import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";

import Footer from "./Footer";
import TopBar from "./Topbar";
import { getNewsPosts } from "../utils/newsPosts";

const Stories = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        getNewsPosts()
            .then((data) => setPosts(data.posts))
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <TopBar />
            <main className="w-full bg-paper">
                <section className="relative flex min-h-[320px] w-full items-center justify-center overflow-hidden bg-navy px-6 py-12 sm:min-h-[360px] sm:py-16">
                    <div
                        className="absolute inset-0 opacity-[0.07]"
                        style={{
                            backgroundImage:
                                "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)",
                            backgroundSize: "24px 24px",
                        }}
                    />
                    <div className="relative mx-auto max-w-5xl text-center">
                        <h1 className="font-display text-3xl font-bold leading-[1.02] text-paper md:text-[2.3rem]">
                            Voices of AQi
                        </h1>
                        <p className="mx-auto mt-5 max-w-4xl font-body text-sm leading-relaxed text-paper/75 sm:text-base md:text-lg">
                            Voices of AQi shares experiences from across our
                            community 
                            <span className="inline-block w-5 border-t border-current align-middle mx-2" />
                            highlighting founders and ventures
                            using Regulation Crowdfunding to bring new ideas
                            and inclusive innovation to life. It offers a look
                            at how diverse perspectives are reshaping access to
                            capital in today&apos;s crowdfunding landscape.
                        </p>
                    </div>
                </section>

                <section className="bg-paper px-4 py-8 sm:px-6 sm:py-12 md:px-8 md:py-16 lg:px-12 lg:py-20">
                    {loading ? (
                        <p className="text-center text-navy font-poppins">
                            Loading stories...
                        </p>
                    ) : (
                        <div className="grid items-start grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-8 md:gap-10 lg:gap-12 mx-auto text-center max-w-sm sm:max-w-2xl md:max-w-4xl lg:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl">
                            {posts.map((post) => (
                                <Link
                                    to={`/blog/${post.slug || post.id}`}
                                    key={post.id}
                                    className="block transition hover:opacity-90 hover:scale-105 duration-300"
                                >
                                    <div className="flex flex-col h-full">
                                        <img
                                            src={post.image}
                                            alt={post.title}
                                            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-sm mx-auto rounded-lg shadow-md"
                                        />
                                        <div className="flex flex-col flex-grow mt-4 sm:mt-6">
                                            <h3 className="mb-2 sm:mb-3 text-base sm:text-lg md:text-xl lg:text-xl font-semibold text-yellow-600 font-poppins leading-snug">
                                                {post.title}
                                            </h3>
                                            <p className="text-navy-2 text-left text-sm sm:text-base md:text-base lg:text-lg max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-sm mx-auto font-poppins font-normal leading-relaxed flex-grow">
                                                {post.excerpt}
                                            </p>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </section>
            </main>
            <section className="bg-paper py-6 px-4 sm:px-8 md:px-16 lg:px-32 xl:px-48">
                <div className="w-full mx-auto text-gray-700 text-[10px] sm:text-xs md:text-sm font-poppins italic leading-relaxed">
                    <p className="text-navy text-center">
                        Content on this page is for informational and
                        educational purposes only and does not constitute
                        investment advice or a recommendation to invest.
                        <br className="hidden sm:block" />
                        <span className="sm:hidden"> </span>
                        Investing in securities offered under Reg CF involves
                        risk, including illiquidity and the possible loss of
                        your entire investment.
                    </p>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Stories;
